import axios from 'axios';

const ADMIN_API_URL = process.env.REACT_APP_API_URL + 'admin/accounts/';

const axiosConfig = {
  withCredentials: true
};

const getAll = (accountId, params) => {
  return axios.get(ADMIN_API_URL + accountId + '/transactions', {
    params,
    ...axiosConfig
  });
};

const getReceipt = (accountId, transactionUuid) => {
  return axios.get(ADMIN_API_URL + accountId + '/transactions/' + transactionUuid + '/receipt', axiosConfig);
};

const TransactionService = {
  getAll,
  getReceipt
};

export default TransactionService;
